<div class="gw-bg-background-elevation-1 gw-border-base gw-m-medium md:gw-m-0">
  <div
    class="gw-bg-background-neutral-1 gw-overflow-hidden md:gw-rounded-[12px]"
  >
    <div
      class="gw-h-[56px] gw-px-medium md:gw-px-x-large gw-flex gw-items-center gw-gap-1 border-bottom"
    >
      <ng-container *ngFor="let item of resolvedBreadcrumb; let i = index">
        <a
          *ngIf="item.path; else breadcrumbText"
          class="gw-text-sm gw-cursor-pointer"
          [ngClass]="{
            'link-active': i === resolvedBreadcrumb.length - 1,
            'link-inactive': i < resolvedBreadcrumb.length - 1
          }"
          [routerLink]="item.path"
        >
          {{ item.label | translate }}
        </a>
        <ng-template #breadcrumbText>
          <span
            class="gw-text-sm"
            [ngClass]="{
              'link-active': i === resolvedBreadcrumb.length - 1,
              'link-inactive': i < resolvedBreadcrumb.length - 1
            }"
          >
            {{ item.label | translate }}
          </span>
        </ng-template>

        <span
          *ngIf="i < resolvedBreadcrumb.length - 1"
          class="gw-text-text-secondary"
        >
          ›
        </span>
      </ng-container>

      <div class="gw-ml-auto gw-flex gw-items-center gw-gap-2">
        <ng-content select="[page-header-actions]"></ng-content>
      </div>
    </div>

    <!--
      Page body:
      Mobile: gap 24px, py-x-large, px-medium, rounded-medium
      Desktop: gap 24px, p-x-large, rounded-medium, max-w-1196px
    -->
    <div
      class="page-body gw-flex gw-flex-col gw-gap-6 gw-text-base gw-bg-background-elevation-1 gw-py-x-large gw-px-medium md:gw-p-x-large gw-w-full md:gw-max-w-[1196px] md:gw-mx-auto"
    >
      <ng-content select="[page-body]"></ng-content>
    </div>
  </div>
</div>
